function isValidEmail(email?: string): boolean {
  const trimEmail = email ? email.trim() : ''
  // eslint-disable-next-line max-len
  const emailRegex = /^[-!#$%&'*+/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/

  return emailRegex.test(trimEmail)
}

export default isValidEmail
